export const actionsRightWidth = 130;
